import messages from "../../../locale/messages";

const validate = values => {

  const errors = {}

  if (!values?.firstName || values?.firstName.trim() == "") {
    errors.firstName = messages.firstNameRequired;
  }

  if (!values?.lastName || values?.lastName.trim() == "") {
    errors.lastName = messages.lastNameRequired;
  }

  if (!values?.email) {
    errors.email = messages.emailRequiredText;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values?.email)) {
    errors.email = messages.emailInvalidText;
  }

  if (!values?.location) {
    errors.location = messages.locationRequired;
  }

  // COMPLIANCE (CCPA/CPRA + ESIGN): the ToS + Privacy consent checkbox is
  // required — blocks submit until the user explicitly accepts.
  if (!values?.acceptedLegal) {
    errors.acceptedLegal = messages.tosPrivacyConsentRequired;
  }

  return errors
}

export default validate;
